'use client';

import Image, { StaticImageData } from 'next/image';
import { LinkButton } from '../button';

interface IBookCardProps {
  title?: string;
  subTitle?: string;
  imageUrl: string | StaticImageData;
  linkText: string;
  linkHref: string;
  desc?: string;
  type?: 0 | 1 | 2;
  themeStyle?: {
    color: string;
    backgroundColor: string;
  };
  // 1 独立产品，数字服务
  category?: 1 | 2;
}

interface IHotTagProps {
  title: string;
  type: number;
}

enum TagType {
  '',
  '最新',
  '热门',
}

const HotTag: React.FC<IHotTagProps> = ({ title, type }) => {
  return (
    <div
      className={`${
        type === 2 ? 'bg-orange' : 'bg-green'
      } rounded px-2 py-1 flex items-center`}
    >
      <span className="text-[10px] -leading-[1px] text-white text-nowrap">
        {title}
      </span>
    </div>
  );
};

const OriginBookCard: React.FC<IBookCardProps> = ({
  title,
  imageUrl,
  subTitle,
  linkText,
  linkHref,
  desc,
  type = 0,
  themeStyle,
  category = 1,
}) => {
  return (
    <div className="bg-white flex-1 flex items-center  justify-center rounded-md shadow-sm relative box-border">
      <div
        className="h-5 w-5 bg-bg rounded-full -ml-10px absolute left-0 top-1/2 -translate-y-1/2"
        style={{ backgroundColor: themeStyle?.backgroundColor }}
      />

      <div className="flex flex-col p-5 items-center">
        <div className="relative">
          <Image
            src={imageUrl}
            height={62}
            width={134}
            className="h-[62px] w-auto max-w-[134px] mobile:h-[50px] mobile:max-w-[108px]"
            alt="工具图标"
          />
          {type > 0 && (
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full mobile:hidden">
              <HotTag title={TagType[type]} type={type} />
            </div>
          )}
        </div>
        {title && (
          <span className="mt-[10px] mb-2 text-base text-primary leading-none line-clamp-1 mobile:text-sm">
            {title}
          </span>
        )}
        <p className="text-sm text-primary/[.6] leading-none mt-[9px] line-clamp-1 mobile:text-xs font-400">
          {subTitle}
        </p>
        <div className="flex justify-center flex-col items-center">
           <span className="text-base mobile:h-5 text-primary leading-none mt-10 line-clamp-1 text-center font-500 mobile:text-sm mobile:-mb-[10px]">
              {desc}
            </span>
          <LinkButton
            linkHref={linkHref}
            color={themeStyle?.color}
            backgroundColor={themeStyle?.backgroundColor}
          >
            {linkText}
          </LinkButton>
        </div>
      </div>
      <div
        className="h-5 w-5 bg-bg rounded-full -mr-10px absolute right-0 top-1/2 -translate-y-1/2"
        style={{ backgroundColor: themeStyle?.backgroundColor }}
      />
      <div className="absolute h-px left-0 top-1/2 w-full px-5">
        <div className="rounded-full w-full border border-dashed border-bg box-border" />
      </div>
    </div>
  );
};

export const BookCard: React.FC<IBookCardProps> = ({
  type = 0,
  category = 1,
  ...rest
}) => {
  if (category === 1) {
    return <OriginBookCard {...rest} type={type} />;
  }

  return (
    <div className="bg-white flex-1 flex flex-col items-center rounded-md shadow-sm relative box-border p-5 min-h-[241px] mobile:m-h-[223px]">
      <div className="relative">
        <Image
          src={rest.imageUrl}
          height={40}
          width={85}
          className="h-[40px] w-auto max-w-[85px] mobile:h-[50px] mobile:max-w-[108px]"
          alt="工具图标"
        />
        {type > 0 && (
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full mobile:hidden">
            <HotTag title={TagType[type]} type={type} />
          </div>
        )}
      </div>
      <span className="text-base text-primary  mt-[10px] line-clamp-1 font-500 mobile:text-sm">
        {rest.title}
      </span>
      <p className="text-sm text-primary/[.6] mt-2 line-clamp-4 mobile:text-xs font-400 flex-1">
        {rest.desc}
      </p>
      <LinkButton
        linkHref={rest.linkHref}
        color={rest.themeStyle?.color}
        backgroundColor={rest.themeStyle?.backgroundColor}
      >
        {rest.linkText}
      </LinkButton>
    </div>
  );
};
